module.exports = __webpack_public_path__ + "media/4x3/lb-e33a49a9.svg";